import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import { Toaster } from "sonner";

import Landing from "@/pages/Landing";
import HowItWorks from "@/pages/HowItWorks";
import Features from "@/pages/Features";
import Story from "@/pages/Story";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Pricing from "@/pages/Pricing";
import Dashboard from "@/pages/Dashboard";
import Pregnancy from "@/pages/Pregnancy";
import Timeline from "@/pages/Timeline";
import Baby from "@/pages/Baby";
import Memories from "@/pages/Memories";
import Letters from "@/pages/Letters";
import Journal from "@/pages/Journal";
import Vaccinations from "@/pages/Vaccinations";
import Academy from "@/pages/Academy";
import CourseDetail from "@/pages/CourseDetail";
import Assistant from "@/pages/Assistant";
import Appointments from "@/pages/Appointments";
import Onboarding from "@/pages/Onboarding";
import Symptoms from "@/pages/Symptoms";
import Medications from "@/pages/Medications";
import MedicalRecords from "@/pages/MedicalRecords";
import Nutrition from "@/pages/Nutrition";
import DeliveryPrep from "@/pages/DeliveryPrep";
import FamilyCircle from "@/pages/FamilyCircle";
import FamilyFeed from "@/pages/FamilyFeed";
import FamilyTasks from "@/pages/FamilyTasks";
import FatherMode from "@/pages/FatherMode";
import GrandparentMode from "@/pages/GrandparentMode";
import Newborn from "@/pages/Newborn";
import Community from "@/pages/Community";
import PreConception from "@/pages/PreConception";
import Yearbook from "@/pages/Yearbook";
import Journey from "@/pages/Journey";
import SharedJourney from "@/pages/SharedJourney";
import AppLayout from "@/components/vansha/AppLayout";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return (
    <div className="min-h-screen flex items-center justify-center text-ink-500" data-testid="auth-loading">
      <span className="font-serif text-2xl italic">Vansha</span>
    </div>
  );
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Toaster position="top-center" richColors />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/how-it-works" element={<HowItWorks />} />
            <Route path="/features" element={<Features />} />
            <Route path="/story" element={<Story />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/share/:code" element={<SharedJourney />} />
            <Route path="/app" element={<Protected><AppLayout /></Protected>}>
              <Route index element={<Navigate to="/app/dashboard" replace />} />
              <Route path="onboarding" element={<Onboarding />} />
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="pregnancy" element={<Pregnancy />} />
              <Route path="timeline" element={<Timeline />} />
              <Route path="baby" element={<Baby />} />
              <Route path="memories" element={<Memories />} />
              <Route path="letters" element={<Letters />} />
              <Route path="journal" element={<Journal />} />
              <Route path="vaccinations" element={<Vaccinations />} />
              <Route path="academy" element={<Academy />} />
              <Route path="academy/:id" element={<CourseDetail />} />
              <Route path="assistant" element={<Assistant />} />
              <Route path="appointments" element={<Appointments />} />
              <Route path="symptoms" element={<Symptoms />} />
              <Route path="medications" element={<Medications />} />
              <Route path="records" element={<MedicalRecords />} />
              <Route path="nutrition" element={<Nutrition />} />
              <Route path="delivery-prep" element={<DeliveryPrep />} />
              <Route path="family" element={<FamilyCircle />} />
              <Route path="feed" element={<FamilyFeed />} />
              <Route path="tasks" element={<FamilyTasks />} />
              <Route path="father" element={<FatherMode />} />
              <Route path="grandparent" element={<GrandparentMode />} />
              <Route path="newborn" element={<Newborn />} />
              <Route path="community" element={<Community />} />
              <Route path="preconception" element={<PreConception />} />
              <Route path="yearbook" element={<Yearbook />} />
              <Route path="journey" element={<Journey />} />
              <Route path="membership" element={<Pricing inApp />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
